class CompareUtil {
  /**
   * Returns an array of the selected compare products from sessionStorage
   * @returns {Array}
   */
  static getSelectedProducts() {
    let compareProducts = theme.storageUtil.get('compare-products', true, true);

    // Migra seleção antiga do localStorage apenas se sessionStorage nunca foi usado
    if (compareProducts == null) {
      const legacyProducts = theme.storageUtil.get('compare-products', true, false);
      if (legacyProducts && legacyProducts.length > 0) {
        CompareUtil.setSelectedProducts(legacyProducts);
        theme.storageUtil.remove('compare-products', false);
        compareProducts = legacyProducts;
      }
    }

    return compareProducts || [];
  }

  /**
   * Sets an array of the selected compare products to sessionStorage
   * @param {Array} compareProducts - An array of product objects to compare
   */
  static setSelectedProducts(compareProducts) {
    theme.storageUtil.set('compare-products', compareProducts, true);
  }

  /**
   * Adds a product id and url to the compare array in sessionStorage
   * @param {string} productId - the product id
   * @param {string} productUrl - the product url
   * @param {boolean} updateDom - whether the dom should be updated or not
   */
  static addToCompare(productId, productUrl, updateDom) {
    const compareProducts = CompareUtil.getSelectedProducts();
    const productIdStr = productId.toString();
    
    // Check if product already exists (comparing as strings to avoid type mismatches)
    const exists = compareProducts.some((product) => product.id.toString() === productIdStr);
    
    if (!exists) {
      compareProducts.push({ id: productIdStr, url: productUrl });
      CompareUtil.setSelectedProducts(compareProducts);
    }
    
    CompareUtil.updateCompareCounters(compareProducts.length);

    if (updateDom) {
      CompareUtil.updateCompareCheckboxes();
    }
  }

  /**
   * Removes a product from the compare array in sessionStorage
   * @param {string} productId - the product id
   * @param {boolean} updateDom - whether the dom should be updated or not
   */
  static removeFromCompare(productId, updateDom) {
    const productIdStr = productId.toString();
    const compareProducts = CompareUtil.getSelectedProducts().filter(
      (product) => product.id.toString() !== productIdStr
    );

    CompareUtil.setSelectedProducts(compareProducts);
    CompareUtil.updateCompareCounters(compareProducts.length);

    if (updateDom) {
      CompareUtil.updateCompareCheckboxes();

      theme.elementUtil.remove(document.getElementById(`compare-basket-${productIdStr}`));

      document.querySelectorAll('.compare-col').forEach((col) => {
        if (col.classList.contains(`compare-col--${productIdStr}`)) {
          col.remove();
        }
      });

      document.dispatchEvent(new CustomEvent('on:product-compare:removed', {
        bubbles: true,
        detail: { productId: productIdStr, count: compareProducts.length }
      }));
    }
  }

  /**
   * Clears all products from the compare array in sessionStorage
   * @param {boolean} updateDom - whether the dom should be updated or not
   */
  static clearCompare(updateDom) {
    const compareProducts = CompareUtil.getSelectedProducts();
    if (compareProducts) {
      compareProducts.forEach((product) => {
        CompareUtil.removeFromCompare(product.id, updateDom);
      });
    }
  }

  /**
   * Set whether the detected checkboxes should be checked or not
   */
  static updateCompareCheckboxes() {
    const compareProducts = CompareUtil.getSelectedProducts();
    document.querySelectorAll('.js-compare-checkbox').forEach((checkbox) => {
      const checkboxProductId = checkbox.dataset.productId.toString();
      checkbox.checked = compareProducts.some(
        (product) => product.id.toString() === checkboxProductId
      );
    });
  }

  /**
   * Returns a count of the number of currently in the compare basket
   * @returns {number}
   */
  static getCompareCount() {
    return CompareUtil.getSelectedProducts().length;
  }

  /**
   * Updates counters on the page with the count of products in the compare basket
   * @param {number} pCount - optionally can pass in the count of products to update
   */
  static updateCompareCounters(pCount) {
    const count = pCount || CompareUtil.getCompareCount();
    document.querySelectorAll('.js-compare-counter').forEach((counter) => {
      counter.innerText = count;
    });
  }
}

/* global SideDrawer */

if (!customElements.get('compare-drawer')) {
  class CompareDrawer extends HTMLElement {
    constructor() {
      super();
      this.openDrawerButton = document.querySelector('.js-open-compare-drawer');
      
      if (this.openDrawerButton) {
        this.statusEmpty = this.openDrawerButton.querySelector('.js-compare-status-empty');
        this.statusFilled = this.openDrawerButton.querySelector('.js-compare-status-filled');
        this.doCompareButton = this.openDrawerButton.querySelector('.js-trigger-compare-modal');
      } else {
        this.doCompareButton = this.querySelector('.js-trigger-compare-modal');
      }
      
      this.clearButtons = document.querySelectorAll('.js-clear-compare');
      this.maxCompare = this.dataset.maxCompare;
      this.compareModal = document.querySelector('.js-compare-modal');
      this.init();
      this.bindEvents();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.clickHandler);
      document.removeEventListener('change', this.changeHandler);
      document.removeEventListener('on:facet-filters:updated', CompareUtil.updateCompareCheckboxes);
    }

    init() {
      CompareUtil.updateCompareCheckboxes();
      CompareUtil.updateCompareCounters();
      this.toggleCompareButton();
      this.updateBasketState();
      setTimeout(() => {
        this.openDrawerButton.removeAttribute('style');
        this.openDrawerButton.classList.add('transition-ready');
      }, 500);

      if (this.compareModal) {
        this.compareModal.querySelector('.details-modal').classList.remove('hidden');
      }
    }

    bindEvents() {
      this.clickHandler = this.handleClick.bind(this);
      this.changeHandler = this.handleChange.bind(this);

      document.addEventListener('click', this.clickHandler);
      document.addEventListener('change', this.changeHandler);
      document.addEventListener('on:facet-filters:updated', CompareUtil.updateCompareCheckboxes);
      
      if (this.doCompareButton) {
        this.doCompareButton.addEventListener('click', this.handleDoCompareClick.bind(this));
      }
      
      if (this.clearButtons && this.clearButtons.length) {
        this.clearButtons.forEach((button) => {
          button.addEventListener('click', this.handleClearCompareClick.bind(this));
        });
      }
    }

    /**
     * Updates the position of the 'Compare' sticky bar
     */
    toggleCompareButton() {
      this.openDrawerButton.classList.remove('is-out');
    }

    /**
     * Handles a 'click' event
     * @param {object} evt - Event object
     */
    handleClick(evt) {
      if (evt.target.classList.contains('js-close-compare')) {
         // Handle close if needed
      }
    }

    /**
     * Handles a 'change' event for comparison checkboxes
     * @param {object} evt - Event object
     */
    handleChange(evt) {
      if (evt.target.classList.contains('js-compare-checkbox')) {
        const productData = evt.target.dataset;

        if (evt.target.checked) {
          if (CompareUtil.getCompareCount() < this.maxCompare) {
            CompareUtil.addToCompare(
              productData.productId.toString(),
              productData.productUrl,
              false
            );
          } else {
            alert(`${theme.strings.compare.limit.replace('[quantity]', this.maxCompare)}`); // eslint-disable-line
            evt.target.checked = false;
          }
        } else {
          CompareUtil.removeFromCompare(productData.productId.toString(), false);
        }

        this.updateBasketState();
        this.toggleCompareButton();
      }
    }

    /**
     * Handle click on the Compare button - Open Modal directly
     */
    handleDoCompareClick() {
      if (CompareUtil.getCompareCount() < 2) {
        // Optional: show message that at least 2 products are needed
        return;
      }
      this.compareModal.dispatchEvent(new CustomEvent('on:product-compare-modal:open'), { bubbles: true });
    }

    /**
     * Handle click on the Clear button
     */
    handleClearCompareClick() {
      CompareUtil.clearCompare(true);
      this.toggleCompareButton();
      this.updateBasketState();
    }

    /**
     * Opens the compare drawer
     * @param {Element} opener - Element that triggered opening of the drawer
     */
    async open(opener) {
      // Repurposed to open modal
      this.handleDoCompareClick();
    }

    /**
     * Closes the compare drawer
     */
    close() {
      // No drawer to close
    }

    /**
     * Updates the text and button state based on number of products in compare basket
     */
    updateBasketState() {
      const compareCount = CompareUtil.getCompareCount();
      
      if (this.doCompareButton) {
        this.doCompareButton.setAttribute('aria-disabled', compareCount < 2);
        // Style disabled button?
        if (compareCount < 2) {
            this.doCompareButton.classList.add('btn--disabled');
        } else {
            this.doCompareButton.classList.remove('btn--disabled');
        }
      }

      if (this.clearButtons && this.clearButtons.length) {
        this.clearButtons.forEach((button) => {
          button.setAttribute('aria-disabled', compareCount === 0);
        });
      }

      if (compareCount > 0) {
        this.statusEmpty.classList.add('hidden');
        this.statusFilled.classList.remove('hidden');
      } else {
        this.statusEmpty.classList.remove('hidden');
        this.statusFilled.classList.add('hidden');
      }
    }

    /**
     * Fetches and renders the products in the compare basket
     */
    async renderCompareBasket() {
      const compareProducts = CompareUtil.getSelectedProducts();
      if (compareProducts) {
        // Reset the previous state if applicable
        this.loadingSpinner.removeAttribute('hidden');
        this.loadingSpinner.removeAttribute('aria-hidden');
        this.compareBasketArea.classList.remove('revealable--in');
        this.compareBasketArea.innerHTML = '';

        // Get the contents of the compare basket
        const compareProductHtmlArr = await CompareDrawer.getBasketProducts(compareProducts);
        compareProductHtmlArr.forEach((compareProductHtml) => {
          this.compareBasketArea.innerHTML += compareProductHtml;
        });

        // Timeout to trigger CSS transition
        setTimeout(() => {
          this.loadingSpinner.setAttribute('hidden', 'true');
          this.loadingSpinner.setAttribute('aria-hidden', 'true');
          this.compareBasketArea.classList.add('revealable--in');

          this.updateBasketState();
        }, 100);
      }
    }

    /**
     * Fetches an array of html for each of the compare products, using the section rendering API
     * @param {Array} compareProducts - An array of product objects to compare
     */
    static async getBasketProducts(compareProducts) {
      const tempHtml = [];
      await Promise.all(
        compareProducts.map(async (product) => {
          await fetch(`${product.url}?sections=product-compare-basket`)
            .then((response) => response.json())
            .then((response) => {
              tempHtml[product.id] = response['product-compare-basket'];
            });
        })
      );

      // Return the html in the order they were added to the compare
      const returnHtml = [];
      compareProducts.forEach((product) => returnHtml.push(tempHtml[product.id]));
      return returnHtml;
    }
  }

  customElements.define('compare-drawer', CompareDrawer);
}
